/**
 * @generated SignedSource<<6f87bd04dfb18d46c690435fa011713b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Client_getAppliances_Query$variables = {};
export type Client_getAppliances_Query$data = {
  readonly appliances: ReadonlyArray<{
    readonly assignee: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly device: {
      readonly lastConnection: string | null;
      readonly lastDisconnection: string | null;
      readonly online: boolean;
    };
    readonly id: string;
    readonly name: string;
    readonly serial: string;
    readonly tags: ReadonlyArray<string>;
  }>;
};
export type Client_getAppliances_Query = {
  response: Client_getAppliances_Query$data;
  variables: Client_getAppliances_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serial",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastConnection",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDisconnection",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "online",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Client_getAppliances_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "appliances",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "device",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Client_getAppliances_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "appliances",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "device",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f6231722c37c9af9e064eca5721ea979",
    "id": null,
    "metadata": {},
    "name": "Client_getAppliances_Query",
    "operationKind": "query",
    "text": "query Client_getAppliances_Query {\n  appliances {\n    id\n    name\n    serial\n    tags\n    device {\n      lastConnection\n      lastDisconnection\n      online\n      id\n    }\n    assignee {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e9fc74cf09b09fcacb84c366b0e4833";

export default node;
